
import AppCustomLanguageSelect from "@/components/CustomLanguageSelect.vue";
import AppDefaultSettings from "@/components/sales/SaleEditSaveModalDefaultSettings.vue";
import AppTotalBox from "@/components/sales/SaleEditSaveModalTotalBox.vue";
import AppSelectSaleLayout from "@/components/SelectSaleLayout.vue";
import Vue from "vue";
import { FrequencyDocumentEditState } from "../../utils/frequency-document-edit-state";

export default Vue.extend({
	data() {
		return {
			preventClose: false,
			loading: false
		};
	},
	props: {
		state: {
			type: Object as () => FrequencyDocumentEditState,
			required: true
		}
	},
	methods: {
		async save() {
			try {
				await this.state.save();
				this.$wf.notify(this.$t("common.success").toString(), "success", 3000, "check");
				if (!this.preventClose) this.cancel();
			} catch(err:any) {
				this.$wf.notify(err.getText(), "danger", 3000, "exclamation-triangle");
			}
			this.preventClose = false;
		},

		async cancel() {
			this.state.saveModalOpen = false;
		},

	},
	components: {
		AppDefaultSettings,
		AppCustomLanguageSelect,
		AppSelectSaleLayout,
		AppTotalBox
	}
});
